import Create from '@/components/toolbox/geoobjectcollection/Create'
import GeoObject from '@/models/GeoObject'
import { getToolboxLayoutOfLayer } from '@/helper/GeoObjectLayoutHelper'
import store from '@/store'

class GeoObjectCollection {
  constructor (data) {
    this.features = data
    this.objects = []
    this.loaded = false
    this.loadingPromise = this.init()
    this.step = 1
    this.selectedLayer = null
    this.selectedVectors = []
    this.fieldLayoutId = null
    this.selectedObjects = []
  }

  async init () {
    if (!this.features || this.loaded) {
      return this
    }
    let promises = []
    for (let i = 0; i < this.features.length; i++) {
      promises.push(new GeoObject({ id: this.features[i].id }).loadingPromise)
    }

    let data = await Promise.all(promises)
    for (let i = 0; i < data.length; i++) {
      data[i].readonly = true
      this.objects.push(data[i])
    }
    this.loaded = true

    return this
  }

  getLayer () {
    if (!this.selectedLayer) {
      return null
    }

    return store.getters['layer/get'](this.selectedLayer)
  }

  getToolboxTabs () {
    switch (this.step) {
      case 2:
        return getToolboxLayoutOfLayer(this.getLayer().typeId)
      case 1:
      default:
        return {
          create: {
            tab: Create,
            icon: 'create'
          }
        }
    }
  }
}

export default GeoObjectCollection
